import React, { useState, useEffect } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import Image from "next/legacy/image";
import * as Text from "@/components/text";
import useWindowSize from "@/hooks/useWindowSize";
import Metadata from "../film/Metadata";
import Award from "../film/Award";
import Button from "../actions/Button";
import { format } from "date-fns";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import { useRouter } from "next/router";
import { localeTexts} from "@/utils/locale";

export default function FeaturedTitle({
  title,
  image,
  slug,
  category = "",
  movies = [],
  content = "",
  publication_date,
  film_metadata = {
    duration: "100",
    year: "2020",
    countries: ["Mexico, Argentina"],
  },
}) {
  const windowSize = useWindowSize();

  const getCountries = (countries) => {
    const res = countries.map((c) => c.countries);
    return res;
  };
  const router = useRouter();
  const [locale, setLocale] = useState("es-MX");
  const t = localeTexts[locale]?.common || {};

    // Configuration for theme name prefixes

  const excludedPrefixes = {
  'es-MX': ['mex', 'línea'],
  'en-US': ['mex', 'line']
  };

  // Sync locale with URL and localStorage

  useEffect(() => {
  if (!router.isReady) return;
  const urlLocale = router.query.locale;
  const storedLocale = typeof window !== "undefined"
  ? localStorage.getItem("amb-locale")
  : null;

  const finalLocale = urlLocale || storedLocale || "es-MX";
  setLocale(finalLocale);
  localStorage.setItem("amb-locale", finalLocale);
  }, [router.isReady, router.query.locale]);


  return (
    <>
      <div className="inline-block h-[auto] w-[100%] p-4 lg:flex lg:max-w-[1207px] lg:flex-row-reverse lg:p-0">
        <img
          src={
            image?.data.attributes.url ||
            "https://images.unsplash.com/photo-1658686873732-c93680078088?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80"
          }
          title=""
          loading="lazy"
          className="h-72 w-full object-cover md:h-96 lg:h-[480px] lg:w-1/2"
          alt="Film picture"
        />
        <div className="bg-white py-4 lg:w-1/2 lg:py-14 lg:pr-10">
          <div className="md:flex md:justify-between md:border-b-2">
            {category && (
              <label className="bg-[#DFE2E5] px-4 py-1 text-xs font-semibold uppercase">
                {category}
              </label>
            )}
            <label className="hidden md:inline-block">
              {format(new Date(publication_date), "dd/MM/yyyy")}
            </label>
          </div>
          <Text.Headline
            className="mt-3 text-black"
            as="h2"
            size={windowSize.width < 720 ? "sm" : "xl"}
          >
            {title}
          </Text.Headline>
          {movies.length ? (
            <Text.Body as="div" className="flex gap-3 py-3" size="md">
              &nbsp;
              {localeTexts[locale].common.sobre} :
              <div>
                {movies.map((movie) => (
                  <Link
                    key={movie?.id}
                    href={`/catalogo/${movie?.attributes?.slug}`}
                  >
                    <Text.Link
                      as="span"
                      label={movie?.attributes?.film_name}
                    ></Text.Link>
                  </Link>
                ))}
              </div>
            </Text.Body>
          ) : null}
          <Text.Body as="p" className="line-clamp-4 text-neutral-700" size="md">
            {content}
          </Text.Body>
          <div className="mt-6 flex justify-center md:justify-start">
            <Link href={`/blog/${slug}`}>
              <Button
                className="px-14 font-semibold lg:px-4"
                trailingIcon={<ArrowRightIcon />}
                color="white-on-black"
                label={localeTexts[locale].common.viewMoreDetails}
              ></Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
